// extracted by mini-css-extract-plugin
export default {"deliveryInfoCard":"deliveryInfoCard_deliveryInfoCard__g9y0J","deliveryInfoCard__comment":"deliveryInfoCard_deliveryInfoCard__comment__MYPX1"};